export enum SocialUserAccountType {
    FACEBOOK = 1,
    GOOGLE = 2,
    GOOGLE_ONE_TAP = 3
}
